export default "__VITE_ASSET__89cgpSwM__"